import { Knob, Track } from './styled'
import { ToggleSwitchProps } from './types'

/**
 * A two state switch.
 *
 * `label` is not rendered. It names the control for a screen reader, which
 * otherwise finds an unlabelled button with no text inside it, so it is required
 * rather than optional.
 *
 * @param {ToggleSwitchProps} props
 * @returns {JSX.Element}
 */
const ToggleSwitch = ({
  isOn,
  label,
  isDisabled = false,
  onToggle,
}: ToggleSwitchProps): JSX.Element => {
  return (
    <Track
      type="button"
      isOn={isOn}
      disabled={isDisabled}
      aria-pressed={isOn}
      aria-label={label}
      onClick={onToggle}
    >
      <Knob isOn={isOn} />
    </Track>
  )
}

export default ToggleSwitch
